export const hero = {
  title: 'Importación directa de equipos de gimnasio',
  subtitle: 'Producto bajo pedido',
  button: 'Ver Productos'
};

export const product = {
  specs: 'Especificaciones',
  weight: 'Peso',
  volume: 'Volumen',
  onRequest: 'Bajo Consulta'
};

export const total = {
  label: 'VALOR TOTAL',
  onRequest: 'Bajo Consulta'
};

export const delivery = {
  shipping: {
    label: 'PREVISIÓN DE EMBARQUE',
    value: '30 Días',
    description: 'Después de recibir la señal'
  },
  delivery: {
    label: 'PREVISIÓN DE ENTREGA',
    value: '60 Días',
    description: 'Después del embarque de los equipos'
  },
  packaging: {
    label: 'EMBALAJE',
    value: 'Plywood',
    description: 'Caja de madera contrachapada'
  },
  warranty: {
    label: 'GARANTÍA',
    value: '1 Año',
    description: 'Piezas de repuesto gratuitas',
    note: '(no incluye flete de transporte de las piezas)'
  },
  manufacturer: {
    label: 'FABRICANTE',
    value: 'BRTW',
    link: 'Visitar sitio'
  }
};

export const financial = {
  title: 'VALOR TOTAL (BRL)',
  installment1: {
    title: 'Cuota 1 — Iniciar proceso',
    description: '30% para iniciar producción'
  },
  installment2: {
    title: 'Cuota 2 — Liberación de embarque',
    description: 'Pago del producto para liberación'
  },
  installment3: {
    title: 'Cuota 3 — Llegada al destino',
    description: 'Puerto o aeropuerto'
  }
};

export const considerations = {
  title: 'Consideración de la Propuesta',
  validity: 'Validez de la propuesta: 15 días',
  deadline: 'Plazo de envío: Los equipos deben ser enviados dentro de 3 meses. Después de este plazo, el contrato será considerado inválido.',
  observation: 'Observación: Al tratarse de la importación directa de 10 equipos, cualquier sustitución o inclusión de nuevos artículos implicará un recálculo de los valores.',
  assembly: 'Montaje y mantenimiento técnico: No incluidos (responsabilidad del comprador).'
};

export const actions = {
  print: 'Imprimir',
  download: 'Descargar en PDF',
  whatsapp: 'Enviar por WhatsApp',
  email: 'Enviar por E-mail',
  whatsappText: '¡Hola! Aquí está la propuesta comercial de Moviis:',
  emailSubject: 'Propuesta Comercial Moviis',
  emailBody: '¡Hola! Aquí está la propuesta comercial de Moviis:'
};

export const contact = {
  meeting: {
    title: 'Agendar una Reunión',
    button: 'Agendar Ahora'
  },
  email: {
    title: 'Contáctenos',
    button: 'Enviar E-mail'
  }
};

export const footer = {
  description: 'Equipos profesionales para gimnasio de alto rendimiento.',
  equipment: {
    title: 'Equipos',
    cardio: 'Cardio',
    strength: 'Musculación',
    functional: 'Funcional'
  },
  info: {
    title: 'Información',
    catalog: 'Catálogo',
    shipping: 'Embarque 30 días',
    delivery: 'Entrega 60 días',
    warranty: 'Garantía 1 año'
  },
  contactInfo: {
    title: 'Contacto',
    address: 'R. Voluntários da Pátria, n.º 2468, 6.º piso',
    zipcode: 'CEP 02402-000',
    phone: '(11) 3255-2877',
    email: 'lp@moviis.com.br',
    hours: 'Lunes a viernes, 08:30 a 18:00 (GMT -03:00)'
  },
  copyright: '© 2026 Moviis. Todos los derechos reservados.',
  poweredBy: 'Powered by Readdy'
};

export default {
  'hero.title': hero.title,
  'hero.subtitle': hero.subtitle,
  'hero.button': hero.button,
  'product.specs': product.specs,
  'product.weight': product.weight,
  'product.volume': product.volume,
  'total.label': total.label
};